export default __webpack_public_path__ + "static/media/photo-template.f9d5aa39.svg";